import { render, staticRenderFns } from "./FCDataSetSettings.vue?vue&type=template&id=5008eafc&scoped=true"
import script from "./FCDataSetSettings.vue?vue&type=script&lang=js"
export * from "./FCDataSetSettings.vue?vue&type=script&lang=js"
import style0 from "./FCDataSetSettings.vue?vue&type=style&index=0&id=5008eafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008eafc",
  null
  
)

export default component.exports